import React from 'react';
import { useNavigate } from 'react-router';
import './BookDetails.css';


const Announcements = () => {
  const navigate = useNavigate(); // we make a variable that points at the function

  const handleClick = (path) => { // and when someone clicks on the button
    navigate(path); // we navigate to the path defined
  };
  const openInNewTab = (url) => { // same as handleClick but opens the link in a new tab
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <section id="book-details" className="book-details">
      <div className="announcements_content">
        <h3 className="section_title">
          Upcoming Events: May 2026
        </h3>

        <div className="announcements_text">
          <p className="body_text">
            I'll be running two tables this month, and everything is driving distance from the Bloomington area.
            First up is <strong><a href="https://bourboncitysteam.com" target="blank">Bourbon City Steam</a></strong> in Louisville, KY. I'll once again be accompanying <strong><a href="https://thearcanist.net/" target="blank">The Arcanist's</a></strong> (our own James Mills) on Friday, May 8th,
            so stop by the Vendor Hall between 3:00pm and 7:00pm if you're in town.
          </p>
          <div className="announcements_image">
            <span>
              <img src="images/BourbonCitySteam2026_resize.jpg" max-width="300px" alt="Bourbon City Steam" /><img src="images/IndyLitCon2026_resize.jpg" max-width="300px" alt="Indy Lit Con" />
            </span>
          </div>
          <p className="body_text">
            Next up will be <strong><a href="https://www.facebook.com/events/dallara-experience-hub/plots-pages-prologues-presents-indy-lit-con/3305278749621874/" target="blank">Indy Lit Con</a></strong> on May 16th. This is a one day event just for local authors, and I'll be there from open to close.
          </p>
          <p className="body_text">
            Also, I still have promo codes for the Children of Nemia audiobook. If you review stuff on your blog or YouTube (or if you know anybody that does), don't hesitate to email me at information@michaelgoe.com and mention the newsletter while you can still snag one 100% for free.
          </p>
          <div className="announcements_image">
            <span>
              <span onClick={() => handleClick('/landing')}><img width="600px" src="images/site-banner_3_2026.jpg" alt="Children of Nemia" /></span>
            </span>
          </div>
        </div>

      </div>
    </section>
  )
}

export default Announcements;
